import React from "react";
import { string, func } from "prop-types";
import FormContext from "./context";

function ValueOf({ name, children }) {
	const { form, update, register, touch, errors, formErrors } = React.useContext(FormContext);

	return typeof children === "function"
		? children({
				value: form[name],
				update: update(name),
				register: register(name),
				touch: touch(name),
				error: errors[name],
				formError: formErrors[name],
		  })
		: form[name];
}

ValueOf.propTypes = {
	name: string.isRequired,
	children: func,
};

export default ValueOf;
